import { Component, EventEmitter, Input, OnChanges, OnDestroy, SimpleChanges, Output } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { Subject } from 'rxjs';

import { DisplayFilterValues } from '../../models/product-filter.models';

import { GridViewEnum } from '@shared/models/grid-type.model';

@Component({
    selector: 'display-filter-icon',
    templateUrl: './display-filter-icon.component.html',
    standalone: true,
    imports: [
        MdIconComponent,
    ],
})

export class DisplayFilterIconComponent implements OnChanges, OnDestroy {
    @Input() public gridType: number;

    @Input() public hideStudioView: boolean;

    @Output() public readonly displayFilterEmitter = new EventEmitter<DisplayFilterValues>();

    public icons: GridViewEnum[] = [];

    public iconSelected = '';

    private readonly destroySubject = new Subject<void>();

    public ngOnChanges(changes: SimpleChanges): void {
        let shouldUpdateIcons = false;

        if (
            changes?.gridType?.currentValue !== changes?.gridType?.previousValue
            || changes?.viewGrid?.currentValue !== changes?.viewGrid?.previousValue
            || changes?.hideStudioView?.currentValue !== changes?.hideStudioView?.previousValue
        ) {
            shouldUpdateIcons = true;
        }

        if (shouldUpdateIcons) {
            this.updateIcons();
            this.updateSelectedIcon(this.gridType);
        }
    }

    private updateIcons(): void {
        this.icons = this.hideStudioView
            ? [GridViewEnum.GRID_2, GridViewEnum.GRID_3]
            : [GridViewEnum.GRID_1, GridViewEnum.GRID_2, GridViewEnum.GRID_3];
    }

    private updateSelectedIcon(defaultValue: number): void {
        const defaultIcon = this.icons?.find(icon => icon.includes(defaultValue.toString()));
        if (defaultIcon) {
            this.iconSelected = defaultIcon;
        } else {
            this.iconSelected = this.icons[0];
        }
    }

    public changeView(view: GridViewEnum): void {
        const iconToGridMap: Record<string, number> = {
            [GridViewEnum.GRID_1]: 1,
            [GridViewEnum.GRID_2]: 2,
            [GridViewEnum.GRID_3]: 3,
        };

        if (this.icons?.includes(view)) {
            this.iconSelected = view;
            this.displayFilterEmitter.emit({ value: iconToGridMap[view] });
        }
    }

    public ngOnDestroy(): void {
        this.icons = [];
        this.iconSelected = '';
        this.destroySubject.next();
        this.destroySubject.complete();
    }
}
